import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {


  constructor() { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const e = <KeyboardEvent>event;
    if (
      /* Allow: Ctrl+A */
      e.charCode === 65 && e.ctrlKey === true ||
      /* Allow: Ctrl+V */
      e.ctrlKey === true && (e.which === 118 || e.which === 86) ||
      /* Allow: Ctrl+c */
      e.ctrlKey === true && (e.which === 99 || e.which === 67) ||
      /* Allow: Ctrl+x */
      e.ctrlKey === true && (e.which === 120 || e.which === 88) ||
      /* Allow: home, end, left, right */
      (e.keyCode >= 35 && e.keyCode <= 39) || (e.charCode >= 35 && e.charCode <= 39)) {
      /* let it happen, don't do anything */
      return;
    }
    if (
      /* numeric only and backspace and tab and enter for Chrome */
      e.charCode >= 48 && e.charCode <= 57 ||
      e.charCode === 8 ||
      e.charCode === 9 ||
      e.charCode === 13 ||
      e.charCode === 46) {
      return;
    } else if (
      /* numeric only and backspace and tab and enter for Firefox */
      e.keyCode === 48 && e.keyCode <= 57 ||
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      e.keyCode === 13 ||
      e.keyCode === 46) {
      return;
    } else {
      e.preventDefault();
    }
  }

}
